import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import data from "./modules/data";
import messages from "./modules/messages";
import centers from "./modules/centers";
import timesheetRecords from "./modules/timesheetRecords";
import navigation from "./modules/navigation";
import courseCalendar from "./modules/course-calendar";
import createPersistedState from "vuex-persistedstate";
import serviceWorker from "./modules/serviceWorker";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    data,
    centers,
    timesheetRecords,
    messages,
    navigation,
    courseCalendar,
    serviceWorker,
  },
  plugins: [
    createPersistedState({
      key: "gaa-staff-vuex",
      paths: ["auth"],
    }),
  ],
});
